{
  "common": {
    "survey": "Survey",
    "cancel": "Cancel",
    "submit": "Submit",
    "previewAndSave": "Preview and save",
    "save": "Save",
    "saveError": "An error occurred while saving",
    "add": "Add",
    "remove": "Remove",
    "edit": "Edit",
    "clear": "Clear",
    "preview": "Preview",
    "search": "Search",
    "showAll": "Show all",
    "showLess": "Show less",
    "continue": "Continue",
    "next": "Next",
    "previous": "Previous",
    "verifyFormData": "Check the information",
    "toFrontPage": "Return to main page",
    "name": "Name",
    "firstName": "First name",
    "lastName": "Surname",
    "username": "Username",
    "studentNumber": "Student number",
    "degreeProgram": "Target group",
    "email": "E-mail",
    "value": "Value",
    "type": "Type",
    "isRequired": "The field is required.",
    "required": "Required",
    "yes": "Yes",
    "no": "No",
    "and": "and",
    "open": "Open",
    "closed": "Closed",
    "closing": "Closing",
    "pending": "Pending",
    "back": "Back",
    "page": "Page",
    "close": "Close",
    "modifiedAt": "Modified",
    "createdAt": "Created",
    "description": "Description",
    "dropdown": {
      "prompt": "Choose an option"
    },
    "status": "Status",
    "version": "Version",
    "select": "Select",
    "question": "Question",
    "periods": {
      "spring": "Spring",
      "fall": "Autumn"
    },
    "dateTime": "Date and time",
    "new": "New",
    "schema": "Survey template"
  },
  "surveyType": {
    "DEGREE_PROGRAM_SURVEY": "HowULearn survey",
    "COURSE_SURVEY": "HowUStudy survey",
    "HUP": "PhD survey",
    "HUT": "HowUTeach survey",
    "NOT_DEFINED": "Not defined"
  },
  "errorPage": {
    "errorHappened": "An error occurred in the application",
    "accessDeniedError": "You do not have access to the page or action you are requesting.",
    "unknownError": "Unknown error",
    "notFound": "The page you requested was not found"
  },
  "confirmButton": {
    "confirmCancel": "Are you sure you want to undo the changes you have made?"
  },
  "languageSelector": {
    "fi": "Suomi",
    "en": "English",
    "sv": "Svenska"
  },
  "inLanguage": {
    "fi": "In Finnish",
    "en": "In English",
    "sv": "In Swedish"
  },
  "login": {
    "chooseUser": "Select user",
    "chooseOrganization": "Select organisation"
  },
  "organizations": {
    "UH": "University of Helsinki",
    "TEST": "Test organisation",
    "AALTO": "Aalto University",
    "HAMK": "Häme University of Applied Sciences",
    "METROPOLIA": "Metropolia University of Applied Sciences",
    "FUNIDATA": "Funidata Testu University",
    "ABO": "Åbo Akademi University"
  },
  "userMenu": {
    "logOut": "Log out",
    "openLogoutMenu": "Open the language and logout menu",
    "closeLogoutMenu": "Close the language logout menu",
    "changeLanguage": "Change language"
  },
  "surveyUserList": {
    "responseDate": "Date of response"
  },
  "frontPage": {
    "intro": "UniHow is a research-based support system for learning and teaching.",
    "yourSurveys": "Surveys applicable to you",
    "youHaveNoSurveys": "There are no surveys applicable to you",
    "wantToStartASurvey": "Do you want to start a new survey?",
    "startSurveyInfo": "View and launch a new survey",
    "startSurvey": "Start a new survey",
    "description": "<h3>This is how UniHow helps you</h3><p>Based on answers received, UniHow produces counter-feedback that encourages the respondent to examine, for example, their own ways of studying or teaching.</p><p>UniHow produces easy-to-read and understandable reports on the groups that responded to the survey. The reports and materials can be used, for example, in the development of teaching.</p><p>The data collected through the system can be easily transferred to statistical analysis programs and used as research data.</p>",
    "whatIsUniHow": "What is UniHow?",
    "surveyBoxList": {
      "surveyTypes": {
        "DEGREE_PROGRAM_SURVEY": "HowULearn surveys",
        "COURSE_SURVEY": "HowUStudy surveys",
        "HUP": "PhD surveys",
        "HUT": "HowUTeach surveys"
      },
      "answerSurvey": "Take the survey",
      "viewFeedback": "Explore the feedback",
      "showMore": "Show more",
      "responseMessages": {
        "answered": "You have completed the survey",
        "notAnswered": "You have not completed the survey",
        "waiting": "Waiting for completion"
      },
      "endingMessages": {
        "ended": "The survey has been closed",
        "notEnded": "The survey will close"
      },
      "feedbackMessages": {
        "notEnoughResponses": "The feedback cannot be displayed because not enough answers were obtained.",
        "notAnswered": "The feedback cannot be displayed because you have not completed the survey.",
        "shownAfterClosed": "The feedback will be displayed after the survey has been closed, if there are enough responses.",
        "feedbackWaiting": "Your feedback is waiting for review",
        "feedbackViewed": "You have reviewed your feedback",
        "hourglassAltText": "Hourglass",
        "closeAltText": "Cross",
        "checkAltText": "Checkmark"
      }
    },
    "instructions": {
      "title": "Instructions for survey respondents",
      "step1": {
        "title": "Take the survey",
        "description": "Start an open survey and answer its questions and statements based on your own studying experiences."
      },
      "step2": {
        "title": "Wait for the survey to close",
        "description": "UniHow calculates the results and creates your personal feedback once all the answers have been collected and the survey is closed. Your answers are compared to those of other participants in the survey."
      },
      "step3": {
        "title": "Explore the feedback",
        "description": "You will receive an email with a link to your personal feedback. The feedback includes expert tips and information about your way of working compared to others who participated in the same survey."
      }
    }
  },
  "links": {
    "activityLog": "Activity log",
    "myHowULearnSurveys": "My HowULearn surveys",
    "myHowUStudySurveys": "My HowUStudy surveys",
    "surveySchemas": "Survey templates",
    "permissions": "Permissions",
    "surveyReports": "Consolidated survey reports",
    "serviceReports": "Service usage reports",
    "degreeProgramSurveys": "HowULearn surveys",
    "courseSurveys": "HowUStudy surveys",
    "teacherSurveys": "HowUTeach surveys",
    "studentInfo": "Information about students",
    "extraSurveyParts": "Additional questions"
  },
  "linkGroupTitles": {
    "ownCourses": "My course implementations",
    "howUTeach": "HowUTeach",
    "settings": "Settings",
    "reports": "Reports",
    "studentSurveys": "Student surveys",
    "surveys": "Surveys"
  },
  "surveyLoadingError": "Error in survey search",
  "surveyProgress": "Survey progress",
  "requiredQuestionInfo": "Questions marked with * are mandatory",
  "responseMessage": {
    "responseSuccess": "Thank you for your reply.",
    "responded": "You have already responded to this survey"
  },
  "survey": {
    "part": "Part",
    "researchConsent": "My responses may be used for research purposes.",
    "researchConsentTitle": "Research consent",
    "responseSentTitle": "Survey has been sent",
    "responseSent": "Survey response has been sent",
    "close": "Close survey",
    "participants": "Participants",
    "scheduling": "Scheduling",
    "remind": "Remind",
    "responseSuccess": "Thank you for your participation! The system will give you feedback based on your answers. The feedback will provide instructions for studying based on your answers, and you will see your own answers in relation to the answers of other students. You will receive an e-mail when your feedback is available in the UniHow service.",
    "reopen": "Open the survey again",
    "export": {
      "title": "Export data",
      "excel": "Export data (Excel)",
      "sensitiveExcel": "Export data for research purposes",
      "description": "You are exporting survey data for research purposes.",
      "enterReason": "Please describe how you intend to use the data. For example, you can mention your research problem and questions.",
      "checkbox": "I confirm using the exported data only for the stated research purposes."
    },
    "sensitiveInfoNotification": "Please do not write health information or other sensitive data in your answers."
  },
  "surveyParticipantsEditor": {
    "NO_EMAIL": "The e-mail address is missing",
    "DUPLICATE_EMAIL": "Another respondent is already using the same e-mail address",
    "NOT_FOUND": "The student was not found.",
    "INVALID_EMAIL": "The e-mail address appears invalid",
    "CHANGING_EMAIL": "A different e-mail address is already stored for this student number. Confirm which one to use.",
    "ALREADY_IN_SURVEY": "Is already a survey recipient.",
    "surveyHasExistingParticipants": "previously added participants.",
    "surveyHasExistingParticipant": "previously added participant.",
    "addParticipantDescription": "You can add or copy students in a list by separating the student numbers with a comma, a space, or line breaks.",
    "addParticipantPlaceholder": "Course implementation identifier or student number",
    "courseRealisationIdHelp": "You can find the course implementation identifier in the study information system. Check the instructions of your own higher education institution on adding participants in the unit.",
    "enterEmail": "Enter e-mail address",
    "selectEmail": "Select e-mail address",
    "studentRegistry": "Study information system",
    "loading": "Retrieving information...",
    "noSelectedCourses": "No course implementations selected",
    "participantsSearchTitle": "Add students using a student number or the course implementation identifier.",
    "recipients": "Recipients",
    "studentsAdded": "students added.",
    "studentAdded": "student added.",
    "studentsRejected": "student numbers rejected.",
    "studentRejected": "student number rejected.",
    "studentsAlreadyAdded": "students are already included in the survey.",
    "studentAlreadyAdded": "student is already included in the survey.",
    "requiresActionPl": "students require correction.",
    "requiresActionSg": "student requires correction.",
    "participantsAlreadyAdded": "provided persons were already present among the recipients.",
    "participantAlreadyAdded": "provided person was already present among the recipients.",
    "missingCourseNames": "untitled course implementations added from the study information system.",
    "missingCourseName": "untitled course implementations added from the study information system.",
    "totalParticipants": "Total participants ${ totalParticipantCount }",
    "missingEmails": "Participants whose e-mail addresses are invalid will not receive an invitation message.",
    "missingEppns": "Participants without an EPPN were excluded from the course implementation.",
    "teacherParticipantsEditor": {
      "searchLabel": "Lisää osallistujia sähköpostiosoitteiden avulla.",
      "placeholder": "Osallistujan sähköposti",
      "description": "Osallistujia voi lisätä useamman kerralla erottamalla sähköpostiosoitteet pilkulla, välilyonnillä tai rivinvaihdolla.",
      "participantAdded": "osallistuja lisätty.",
      "participantsAdded": "osallistujaa lisätty.",
      "participantRejected": "sähköpösti hylätty.",
      "participantsRejected": "sähköpöstia hylätty.",
      "recipients": "Sähköpostiosoitteiden kautta lisätyt osallistujat",
      "NOT_FOUND": "Henkilöä ei löytynyt."
    }
  },
  "addSurveyParticipants": {
    "title": "Edit survey participants",
    "editParticipants": "Edit participants",
    "saved": "Participants saved"
  },
  "editSurvey": {
    "title": "Edit survey"
  },
  "startSurvey": {
    "schemaInfo": {
      "title": "Survey template details",
      "version": "Survey template version"
    },
    "courseSurvey": {
      "startDate": "Survey start date",
      "endDate": "End date of the survey and opening of the summary",
      "startDateHelp": "Setting the start date to the past will immediately start the survey.",
      "endDateHelp": "A summary of the survey can be seen at this time."
    },
    "startTitle": "Start of survey",
    "endTitle": "End of survey",
    "startSurvey": "Start survey",
    "selectSchema": "Select type",
    "content": "Content",
    "noSelectedParticipants": "no selected participants",
    "basicInfo": "Basic information",
    "name": "Name",
    "nameDescription": {
      "degreeProgramSurvey": "You can add a more specific part to the survey name, such as \"Group 1\".",
      "defaultSurvey": "Give the survey a descriptive name. The name will be shown in this form to the participants."
    },
    "recipients": "Students",
    "courses": "Course implementations",
    "introduction": "Introduction",
    "introductionDescription": "If you wish, you can edit the introduction text of the survey which is displayed to the participants.",
    "completion": "Completion",
    "conclusionDescription": "If you wish, you can edit the closing text of the survey which is displayed to the participants.",
    "messages": "Timing and messages",
    "selectDegreeProgram": "Select the group of students you want to target",
    "degreeProgramNotSelected": "-",
    "degreeProgramDescription": "In the drop-down menu, select the group of students you want to target",
    "email": {
      "invitationTitle": "Survey opening and invitation message",
      "invitationTitleDescription": "The invitation message will be e-mailed to the student when the survey opens. The invitation message can be edited. Use the Set default text button to restore the original text.",
      "endingTitle": "Survey closing and closing message",
      "endingTitleDescription": "The survey closing message informs the student that their feedback can now be read. The message can be edited. Use the Set default text button to restore the original text.",
      "setDefaultTitle": "Set default heading",
      "emailTitle": "Message heading",
      "setDefaultContent": "Set default text",
      "emailContent": "Message content",
      "invitationEmailContentHelp": "Help text for creating the content of an invitation message",
      "endingEmailContentHelp": "Help text for creating the content of a closing message"
    },
    "researchConsent": {
      "title": "Research permit",
      "consentNotNeeded": "No research permit is needed",
      "description": "(Use this only if you have discussed this with the unit responsible for the research at your university)"
    },
    "participantsAndScheduling": "Participants",
    "scheduling": "Scheduling",
    "startDate": "Survey start date",
    "startDateHelp": "The survey invitation messages will be sent at this time. Setting the start date to the past will immediately start the survey.",
    "endDate": "End date of the survey and opening of the feedback",
    "endDateHelp": "The survey feedback will open at this time.",
    "submitSuccess": "Survey created successfully",
    "submitSuccessLinkExplanation": "Direct link to the survey (note: the link works only for those who have been invited to the survey): ",
    "viewQuestions": {
      "view": "View survey questions",
      "title": "Survey questions"
    },
    "surveyParts": {
      "title": "Survey elements",
      "introduction": "The survey template contains the following survey elements."
    },
    "extraSurveyPart": {
      "title": "Additional questions",
      "introduction": "You can select additional questions to be shown at the end of a survey. They may be configured, for example, for a specific degree programme.",
      "add": "Select additional questions",
      "help": "Select the additional questions you want to add to the survey. The questions and statements of the additional questions are shown to respondents at the end of the survey after the questions and statements of the actual survey form."
    },
    "reminder": {
      "addReminderSchedule": "Add reminder message timing"
    },
    "courseList": {
      "courseCode": "Course implementation identifier: ${ code }",
      "numberOfParticipants": "Total number of participants in course implementation: ${ amount }",
      "noSelectedCourses": "no course implementations selected",
      "participantsInfo": "The list of participants in the course implementation may change until the registrations have been confirmed."
    }
  },
  "surveyReminder": {
    "title": "Survey reminder message",
    "messageSent": "Survey reminder message sent"
  },
  "viewSurveyResponse": {
    "title": "Responses"
  },
  "surveySummary": {
    "title": "Feedback",
    "summaryHeading": "Summary",
    "radarChartExplanation": "Summary",
    "radarChartItemDescription": "${ name }: your average: ${ userAverage }. Group average: ${ groupAverage }",
    "userAverage": "Your average",
    "groupAverage": "Group average",
    "userTotal": "Your total",
    "improvementSuggestions": "Tips for development",
    "interpretation": "Interpretation of feedback",
    "average": "Average",
    "standardDeviation": "Standard deviation",
    "value1Explanation": "1 – Weakly describes your situation",
    "value5Explanation": "5 – Strongly describes your situation",
    "feedbackComputedAt": "Feedback calculated",
    "ownResponse": "Own responses related to feedback",
    "responseDate": "Responded"
  },
  "richText": {
    "bold": "boldface",
    "italic": "italic",
    "underline": "underline",
    "ul": "list",
    "ol": "numbered list"
  },
  "pageNotFound": "The page cannot be found",
  "connectionError": "Connection error",
  "errorInResponseTo": "Error message for call",
  "header": {
    "siteTitle": "UniHow",
    "logo": {
      "label": "UniHow front page",
      "description": "UniHow logo"
    },
    "navigation": {
      "surveys": "Surveys",
      "surveySchemas": "Survey templates",
      "adminTools": "Administrator tools"
    },
    "openMenu": "Open navigation",
    "closeMenu": "Close navigation"
  },
  "footer": {
    "switchboard": "Telephone",
    "dps": "Privacy notice",
    "accessibilityStatement": "Accessibility statement",
    "externalLink": "Opens in a new tab"
  },
  "editor": {
    "identifier": "Identifier",
    "identifierError": "The identifier is reserved or invalid. The identifier must contain only uppercase or lowercase letters, digits, and underscores (_) or hyphens (-).",
    "title": "Name",
    "description": "Description (not shown to respondents)",
    "surveySchema": {
      "titlePlaceholder": "Survey template name",
      "identifierPlaceholder": "Survey template identifier",
      "descriptionPlaceholder": "Survey template description",
      "typePlaceholder": "Select survey type",
      "introduction": "Default introduction text for survey",
      "completion": "Default survey completion text",
      "feedbackIntroduction": "Feedback introduction",
      "feedbackIntroductionInfo": "Once the survey closes, the respondents will receive personalised feedback based on the dimensions determined by the survey elements. In the field below, specify the summary text of the entire feedback view to explain its purpose and to provide, for example, reading instructions for it",
      "preview": {
        "newSchemaStatusExplanation": "If you save a survey template as a draft, it cannot yet be used in surveys. If you save a survey template as completed, it can be used in surveys. You can continue editing the survey template later.",
        "existingSchemaStatusExplanation": "If you save a survey template as a draft, the changes will not be updated in surveys with which the survey element is associated. You can continue editing the survey template later. If you save a survey template as completed, the modified survey template will be applied to the surveys with which it is associated and which have not yet been scheduled."
      },
      "edit": {
        "infoTitle": "Edit the survey template",
        "inUseExplanation": "<p>This survey template is already in use in surveys. You can edit the feedback summary text. The edited text is updated in surveys and feedback items that use the survey template.</p><p>If you want to edit the survey elements that are associated with the survey template, you must first create a new version of it.</p>",
        "notInUseExplanation": "<p>This survey template has not yet been used to launch surveys. You can freely edit the survey template.</p><p>Please note that after the survey template is used in one or more surveys, you must create a new version of the template before you can edit it.</p>"
      },
      "newVersion": {
        "infoTitle": "New version of survey template",
        "infoContent": "You created a new version of the survey template. After saving the new version, it will overwrite the older version of this survey template. Users who start surveys will only see the latest version of the survey template. Editing the new version of the survey template will not affect the data of surveys that have already been started."
      },
      "extraSurveyPart": "Additional questions",
      "addExtraSurveyPart": "Select additional questions",
      "invitationEmailTitle": "Invitation message"
    },
    "surveySchemaPart": {
      "titlePlaceholder": "Name of survey element",
      "identifierPlaceholder": "Survey element identifier",
      "descriptionPlaceholder": "Description of survey element"
    },
    "surveySchemaPartPreview": {
      "previewDimensionCategory": "Preview dimension ${ variableName } feedback category",
      "noPreviewDimensions": "No dimensions to preview.",
      "unnamedDimension": "Unnamed dimension",
      "unnamedCategory": "Unnamed category",
      "noLinkedQuestions": "There are no questions associated with dimension ${ variableName }, so a preview cannot be displayed.",
      "connectedSchemaNotInUseExplanation": "The survey element is used in survey templates that have not yet been used to launch a survey. The modified survey element is updated in these survey templates.",
      "connectedSchemaInUseExplanation": "The survey element is used in survey templates that have already been used to launch a survey. Select the survey templates in which the modified survey element will be updated. When updating, new versions of these survey templates will be created.",
      "variableQuestionsNotSelected": "The survey element has dimensions for which no statements have been selected"
    },
    "surveySchemaParts": {
      "schemaParts": "Survey template parts",
      "schemaPartsInfo": "The survey template is the entity with which the survey is launched. Select which survey elements the survey template consists of.",
      "editSchemaParts": "Edit survey elements",
      "chooseSchemaParts": "Select the survey elements you want to add",
      "loadMoreSchemaParts": "Show more survey elements",
      "selectSchemaParts": "Select elements",
      "updateSchemaPartVersion": "Update version"
    }
  },
  "surveySchemas": {
    "title": "Survey templates",
    "schema": "Survey template",
    "schemas": "Survey templates",
    "schemaIntroduction": "Survey templates are entities compiled from survey elements, on the basis of which surveys are launched.",
    "createNew": "Create new survey template",
    "surveySchemaList": {
      "header": {
        "name": "Name",
        "code": "Identifier",
        "version": "Version",
        "status": "Status",
        "lastEdited": "Modified"
      },
      "types": {
        "DEGREE_PROGRAM_SURVEY": "HowULearn survey templates",
        "COURSE_SURVEY": "HowUStudy survey templates",
        "HUP": "PhD survey templates",
        "HUT": "HowUTeach survey templates"
      }
    }
  },
  "surveyParts": {
    "identifier": "Identifier",
    "name": "Survey element name",
    "required": "Required question",
    "isRequired": "The question is mandatory",
    "description": "Description (not shown to respondents)",
    "questions": "Questions",
    "nQuestionsPlural": "questions",
    "nQuestionsSingular": "question",
    "addElement": "Add an element",
    "responseOption": {
      "empty": "The answer option is missing"
    },
    "dropdown": {
      "addOption": "Add an option",
      "question": {
        "fi": "Kysymys tai väittämä",
        "sv": "Fråga eller påstående",
        "en": "Question or statement"
      },
      "option": {
        "fi": "Vastausvaihtoehto",
        "sv": "Svarsalternativ",
        "en": "Response option"
      }
    },
    "radioButtonGroup": {
      "addOption": "Add radio button",
      "question": {
        "fi": "Kysymys tai väittämä",
        "sv": "Fråga eller påstående",
        "en": "Question or statement"
      },
      "option": {
        "fi": "Vastausvaihtoehto",
        "sv": "Svarsalternativ",
        "en": "Response option"
      }
    },
    "checkboxGroup": {
      "addOption": "Add check box",
      "question": {
        "fi": "Kysymys tai väittämä",
        "sv": "Fråga eller påstående",
        "en": "Question or statement"
      },
      "option": {
        "fi": "Vastausvaihtoehto",
        "sv": "Svarsalternativ",
        "en": "Response option"
      }
    },
    "likert": {
      "questions": "Questions or statements",
      "addQuestion": "Add question or statement",
      "addValue": "Add value",
      "scale": "Scale",
      "scaleStartValue": "Scale start value"
    },
    "itemTitles": {
      "textField": "Open-ended question",
      "likert": "Likert",
      "customLikert": "Custom",
      "heading": "Subheading",
      "instructionText": "Instruction text",
      "dropdown": "Drop-down list",
      "radioButtonGroup": "Radio buttons",
      "checkboxGroup": "Check boxes"
    },
    "titleMissing": "No heading",
    "descriptionMissing": "No description",
    "validation": {
      "question": {
        "code": {
          "invalid": "The question ID \"${value}\" is invalid",
          "duplicate": "The question ID \"${value}\" has been used more than once"
        }
      }
    }
  },
  "surveySchemaParts": {
    "schemaParts": "Survey elements",
    "schemaPartsIntroduction": "Survey elements are pre-created collections of questions related to a specific topic. The actual survey templates are compiled from the survey elements.",
    "namePlaceholder": "Name of survey element",
    "identifierPlaceholder": "Survey element identifier",
    "descriptionPlaceholder": "Description of survey element",
    "createNew": "Create survey element",
    "surveyPart": "Survey element",
    "partTitle": "Heading of survey element",
    "selectSurveyType": "Select survey type",
    "limitedEditingInformationTitle": "Edit survey element",
    "limitedEditingInformation": "This survey element is already in use in surveys. You can edit the text in the survey element to correct typos. The edited text is updated in the survey templates that use the survey element and in surveys created from these survey templates. To edit the structure of a survey element or change its questions or statements, create a new version of the survey element.",
    "newCopyInformationTitle": "Copy of survey element",
    "newCopyInformation": "You created a copy of the survey element. You can edit the data in the survey element, and delete, add, and edit questions, statements or dimensions. When you save the copy of the survey element, it will appear to users as a new survey element. Note that even if the identifier of the survey element is changed automatically, the identifiers of the questions and statements will remain unchanged. It is recommended that you change these before saving the changes.",
    "newVersionInformationTitle": "New version of the survey element",
    "newVersionInformation": "You created a new version of the survey element, which you can freely edit. When you save a new version, you can choose which survey templates to apply the new version to. Editing the new version of the survey template will not affect the data of surveys that have already been started.",
    "dimensions": {
      "dimensions": "Dimensions",
      "dimension": "Dimension",
      "name": "Dimension name",
      "nameDescription": "Enter a name for the dimension, visible to the user in the feedback",
      "questionsDescription": "Select the questions whose answers make up the result of this dimension. Note that you can only select likert statements with the same scale.",
      "description": "Dimension description",
      "descriptionDescription": "This common part is shown to all respondents",
      "add": "Add dimension",
      "type": {
        "relative": "Dimension – average",
        "absolute": "Dimension – norm"
      },
      "relativeFeedback": {
        "belowAverage": "Below average",
        "average": "Average",
        "overAverage": "Above average",
        "feedback": "Feedback relative to average",
        "improvementSuggestion": "Tips for development",
        "previewImageAlt": "Visualisation of feedback relative to average",
        "categoryError": "The category ${category} was not identified as a valid feedback category"
      },
      "absoluteFeedback": {
        "values": "Normative scale",
        "valuesDescription": "Specify the scale of the normative dimension, the values of which the total score of the user’s responses will be compared to. On the tabs below, you can specify individual feedback items corresponding to the scale.",
        "addValue": "Add value",
        "feedback": "Your value in relation to the norm",
        "improvementSuggestion": "Interpretation of results"
      },
      "extraInfo": {
        "heading": "Additional information",
        "title": "Customisable additional information",
        "description": "Additional information is attached to the dimension and eventually displayed to survey participants in their survey results. You can add the information in three languages.",
        "edit": "Edit additional information",
        "editDescription": "You are editing the additional information for dimension <strong>${ dimensionName }</strong>. The information is attached to the dimension and eventually displayed to survey participants in their survey results.",
        "delete": "Remove additional information",
        "deleteConfirmation": "Are you sure you want to remove all additional information for this dimension?",
        "titlefi": "Title (FI)",
        "titlesv": "Title (SV)",
        "titleen": "Title (EN)",
        "infofi": "Additional information (FI)",
        "infosv": "Additional information (SV)",
        "infoen": "Additional information (EN)",
        "noExtraInfo": "No additional information",
        "requiredDescription": "The fields are mandatory at least in one language"
      }
    },
    "schemaPartCount": "survey elements",
    "browse": "Browse survey elements",
    "search": {
      "heading": "Search and filter",
      "titleSearch": "Search by name or code",
      "filter": "Filter",
      "filterOptions": {
        "selfMade": "Created by me"
      }
    },
    "selectedSchemaPartTitle": "Selected survey elements",
    "noSelectedSchemaParts": "No selected survey elements",
    "noSelectedSchemaPart": "No selected survey element",
    "preview": {
      "newSurveyPartStateExplanation": "If you save a survey element as a draft, it can be enabled in survey templates that are also drafts. If you save a survey element as completed, it can be enabled in survey templates that are also completed. You can continue editing the survey element later.",
      "existingSurveyPartStateExplanation": "If you save a survey element as a draft, the changes will not be updated in survey elements with which the survey element is associated. You can continue editing the survey element later. If you save the survey as completed, the modified survey element will be applied to the survey templates with which it is associated."
    },
    "extraSurveyPart": "Additional questions"
  },
  "extraSurveyParts": {
    "title": "Additional question sets",
    "createNew": "Create an additional question set",
    "loadMore": "Show more additional questions",
    "extraPartsIntroduction": "Additional question sets are a predetermined set of questions that can be attached to the end of the survey you are starting. Additional questions can be used to supplement the survey template on a survey-by-survey basis.",
    "surveyPart": "Additional question set",
    "namePlaceholder": "Name of additional question set",
    "identifierPlaceholder": "Additional question set identifier",
    "descriptionPlaceholder": "Description of additional question set",
    "partTitle": "Title of additional question set",
    "newCopyInformationTitle": "Copy of additional question set",
    "newCopyInformation": "You created a copy of the additional question set. You can freely edit the additional questions in the copy without affecting the original additional questions or surveys that use them. Note that even if the identifier of the survey element is changed automatically, the identifiers of the questions and statements will remain unchanged. It is recommended that you change these before saving the changes.",
    "limitedEditingInformation": "These additional questions are already in use in the survey. You can edit the text in the survey element to correct typos. The edited text is also updated in surveys in progress. To edit the structure of a survey element or change its questions or statements, create a new additional question set.",
    "limitedEditingInformationTitle": "Edit additional questions",
    "selectedSchemaPartTitle": "Selected additional question set",
    "noSelectedSchemaPart": "No additional question set selected",
    "preview": {
      "newSurveyPartStateExplanation": "If you save an additional questions element as published, it can be used in surveys. You can continue editing the additional questions element later.",
      "existingSurveyPartStateExplanation": "If you save an additional questions element as published, it can be used in surveys. You can continue editing the additional questions element later."
    },
    "browse": "Browse additional question sets",
    "searchResult": "Additional question sets matching the search",
    "extraPartCount": "additional questions",
    "sensitiveInfoNotification": "Please do not ask for health information or other sensitive information"
  },
  "manageSurveys": {
    "openSurveys": "Open surveys",
    "hulSurveys": "HowULearn surveys",
    "husSurveys": "HowUStudy surveys",
    "hupSurveys": "PhD surveys",
    "hutSurveys": "HowUTeach surveys",
    "openStudyProgramSurveys": "Open HowULearn surveys",
    "openCourseSurveys": "Open HowUStudy surveys",
    "closedSurveys": "Closed surveys",
    "closedStudyProgramSurveys": "Closed HowULearn surveys",
    "closedCourseSurveys": "Closed HowUStudy surveys",
    "confirmCloseSurvey": "Confirm closing the survey",
    "nSurveys": "surveys",
    "nParticipants": "${ count } participants",
    "nSurveySchemas": "survey templates",
    "showArchived": "Show archived",
    "state": "State",
    "responseTime": "Response time",
    "numberOfResponses": "Responses",
    "quickSteps": "Quick steps",
    "addParticipant": "Add participant",
    "removeParticipant": "Remove participant",
    "removeParticipantConfirm": "Are you sure you want to remove the participant?",
    "removeAnswers": "Remove responses",
    "removeAnswersConfirm": "Are you sure you want to remove the participant’s responses?",
    "participants": "Participants",
    "closeSurvey": "Close survey",
    "editScheduling": "Edit scheduling",
    "notEnoughResponses": "Not enough responses",
    "closeSurveyAreYouSure": "Are you sure you want to close the survey? You can reopen a closed survey with closed survey actions, if you wish.",
    "browseSurveys": "Browse surveys",
    "startSurvey": "Start survey",
    "reopen": {
      "title": "Open survey",
      "description": "Specify the end time for the survey to be reopened, as well as the opening time of the feedback. Once you open a survey, you can add or remove participants, or send a reminder about the survey as you normally would.",
      "doNotSendStartNotification": "Do not send an invitation message",
      "newParticipants": {
        "title": "New recipients",
        "description": "You can add new survey participants that will receive an invitation to the survey. A reopened survey can also be answered by previously invited participants who have not yet responded to the survey."
      }
    },
    "scheduling": {
      "title": "Edit survey scheduling",
      "reminderMessageInfo": "Inform students participating in the survey about the new closing time of the survey.",
      "saveAndSendMessage": "Save and send",
      "surveyRescheduledAndReminderSent": "The new closing time of the survey has been set to ${ endDate } and a notification of this has been sent to all participants."
    },
    "search": {
      "title": "search",
      "hide": "Hide search",
      "titleSearchPlaceholder": "Search with survey name",
      "degreeProgramSearchPlaceholder": "Target group",
      "surveyStartedAfterPlaceholder": "Start date after",
      "surveyStartedBeforePlaceholder": "Start date before",
      "stateSearchPlaceholder": "Survey status",
      "surveyNameLabel": "Survey name"
    }
  },
  "surveyStatistics": {
    "responseCount": "Responses",
    "openQuestionCount": "Open-ended questions in this survey:",
    "researchConsentGivenCount": "Research permits",
    "reminderSentAt": "Reminder message sent",
    "feedbackViewCount": "Feedback viewed by",
    "feedbackViewCountDisclaimer": "Collection of follow-up data started on 9 December 2019",
    "smallest": "Min",
    "largest": "Max",
    "noStatsUntilClosed": "The survey results can only be displayed after the survey is closed.",
    "notEnoughResponses": "The survey results cannot be displayed because there are not enough answers.",
    "computingStatistics": "The survey results cannot be displayed yet because they are still being counted",
    "dimensions": "Dimensions",
    "otherAnswers": "Distributions of other responses",
    "answerDistributions": "Distributions of answers",
    "extraQuestions": "Extra questions",
    "responseDistribution": "Response distribution",
    "responsesToOpenQuestions": "Answers to open-ended questions",
    "dimensionStatements": "Dimension statements",
    "statisticsComputedAt": "Statistics computation date",
    "reminderTimes": "Scheduled reminder messages",
    "viewOpenQuestionResponseReport": "View answers to open-ended questions"
  },
  "feedbackBox": {
    "feedback": "Contact",
    "placeholder": "Contact us or give feedback on the service...",
    "submit": "Submit",
    "thanks": "Thanks"
  },
  "surveyResponseTimeEnd": {
    "warning": "Please note that the survey closes at ${endTime}, after which the response will no longer be accepted.",
    "timeout": "The survey has closed and your answers could not be saved."
  },
  "textInput": {
    "maxLength": "The maximum number of characters in the field is "
  },
  "status": {
    "DRAFT": "Draft",
    "PUBLISHED": "Published",
    "IN_USE": "In use",
    "NOTUSED": "Not in use",
    "ARCHIVED": "Archived"
  },
  "actions": {
    "archive": "Archive",
    "confirmArchiveSurveySchema": "Are you sure you want to archive the survey template? An archived survey template can no longer be used to create new surveys.",
    "viewVersionHistory": "View version history",
    "createNewCopy": "Create new copy",
    "createNewVersion": "Create new version",
    "edit": "Edit"
  },
  "environment": {
    "info": {
      "demo": "Note! This is a demo environment."
    }
  },
  "permissionManagement": {
    "title": "Permissions management",
    "basicInfo": "Basic information",
    "description": "Permissions management",
    "user": "User",
    "saveSuccess": "Changes saved successfully",
    "role": "Role",
    "generalRoles": "General roles",
    "surveyRoles": "Survey roles",
    "noRole": "No role",
    "anyRole": "Any role",
    "all": "All",
    "searchUsers": "Search users",
    "roleFilters": "Filter by role",
    "searchFilter": "Search filter",
    "clearFilters": "Clear filters"
  },
  "activityLog": {
    "activityLog": "Activity log",
    "action": "Action",
    "exportReason": "Export reason (en)",
    "EXPORT_DATA": "Export",
    "EXPORT_SENSITIVE_DATA": "Research export"
  },
  "MESSAGES": {
    "defaultSurveyInvitationTitle": {
      "DEGREE_PROGRAM_SURVEY": "Invitation to HowULearn survey",
      "COURSE_SURVEY": "Invitation to HowUStudy survey",
      "HUP": "Invitation to PhD survey",
      "HUT": "Invitation to HowUTeach survey"
    },
    "defaultSurveyInvitationContent": {
      "DEGREE_PROGRAM_SURVEY": "Hi! Welcome to complete the HowULearn survey regarding learning and studying. HowULearn surveys support students’ learning and studying and the development of teaching quality.\n\nOnce the survey has ended, you will receive personal feedback based on your survey responses. The feedback also includes research-based tips that support learning, formulated by senior lecturers in university pedagogy and counselling psychologists. In addition, you can compare your responses in the various sections of the survey to those of other students.\n\nThe UniHow service also compiles a summary of the survey responses, with the responses processed at the group level. Based on the feedback of the survey, the education organiser, teachers and the education management can develop the teaching to better support the students’ studies and the quality of the teaching.\n\nYou can complete the survey after logging into the service with your university’s account. After the survey has been closed, you can view the feedback on the UniHow service.\n\nView the survey: [QUESTIONNAIRE_LINK_TAG].\n\nPlease complete the survey by [QUESTIONNAIRE_END_DATE_TAG].\n\nThank you in advance for participating!\n\nThis message has been automatically sent by UniHow. You cannot reply to the message. UniHow is a Finnish support tool for learning and teaching development, which Funidata Oy and the University of Helsinki are developing jointly. For more information about Funidata and UniHow, visit https://funidata.fi/palvelut/unihow.\n",
      "COURSE_SURVEY": "Hi! Welcome to complete the HowULearn survey regarding learning and studying. HowULearn surveys support students’ learning and studying and the development of teaching quality.\n\nOnce the survey has ended, you will receive personal feedback based on your survey responses. The feedback also includes research-based tips that support learning, formulated by senior lecturers in university pedagogy and counselling psychologists. In addition, you can compare your responses in the various sections of the survey to those of other students.\n\nThe UniHow service also compiles a summary of the survey responses, with the responses processed at the group level. Based on the feedback of the survey, the education organiser, teachers and the education management can develop the teaching to better support the students’ studies and the quality of the teaching.\n\nYou can complete the survey after logging into the service with your university’s account. After the survey has been closed, you can view the feedback on the UniHow service.\n\nView the survey: [QUESTIONNAIRE_LINK_TAG].\n\nPlease complete the survey by [QUESTIONNAIRE_END_DATE_TAG].\n\nThank you in advance for participating!\n\nThis message has been automatically sent by UniHow. You cannot reply to the message. UniHow is a Finnish support tool for learning and teaching development, which Funidata Oy and the University of Helsinki are developing jointly. For more information about Funidata and UniHow, visit https://funidata.fi/palvelut/unihow.\n",
      "HUP": "Hi!\n\nWelcome to the PhD survey, which looks into your doctoral experience. The goal of the PhD survey is to help you analyse your experiences about writing your doctoral dissertation and identify the factors that affect it. The survey feedback will be used in the development of doctoral education.\n\nOnce the survey has ended, you will receive feedback based on your responses. The feedback will include information and tips from researchers and experts of doctoral education to support your doctoral path. You will also get to compare your responses to the responses of other doctoral researchers.\n\nThe UniHow service creates a summary of the survey responses, with the responses processed at group level. Based on the survey feedback, doctoral education can be developed to better support the progress and well-being of doctoral researchers. You can complete the survey after logging into the service with your university’s account. After the survey has closed, you can view the feedback in the UniHow service.\n\nView the survey: [QUESTIONNAIRE_LINK_TAG].\n\nPlease complete the survey by [QUESTIONNAIRE_END_DATE_TAG].\n\nThank you in advance for participating!\n\nThis message has been automatically sent by UniHow. You cannot reply to the message. UniHow is a Finnish support tool for learning and teaching development, which Funidata Oy and the University of Helsinki are developing jointly. For more information about Funidata and UniHow, visit https://funidata.fi/palvelut/unihow.\n",
      "HUT": "Hi! Welcome to complete the HowUTeach survey regarding teaching.\n\nOnce the survey has ended, you will receive personal feedback based on your survey responses. The feedback also includes research-based tips that support teaching, formulated by senior lecturers in university pedagogy. In addition, you can compare your responses in the various sections of the survey to those of other respondents.\n\nThe UniHow service also compiles a summary of the survey responses, with the responses processed at the group level.\n\nYou can complete the survey after logging into the service with your university’s account. After the survey has been closed, you can view the feedback in the UniHow service.\n\nView the survey: [QUESTIONNAIRE_LINK_TAG].\n\nPlease complete the survey by [QUESTIONNAIRE_END_DATE_TAG].\n\nThank you in advance for participating!\n\nThis message has been automatically sent by UniHow. You cannot reply to the message. UniHow is a Finnish support tool for learning and teaching development, which Funidata Oy and the University of Helsinki are developing jointly. For more information about Funidata and UniHow, visit https://funidata.fi/palvelut/unihow.\n"
    },
    "defaultSurveyEndedTitle": {
      "DEGREE_PROGRAM_SURVEY": "Your HowULearn-feedback is now available",
      "COURSE_SURVEY": "",
      "HUP": "Your PhD-feedback is now available",
      "HUT": "Your HowUTeach-feedback is now available"
    },
    "defaultSurveyEndedContent": {
      "DEGREE_PROGRAM_SURVEY": "Hi!\n\nYou have responded to a HowULearn survey regarding learning and studying. Check out the feedback in the UniHow service at [QUESTIONNAIRE_FEEDBACK_LINK_TAG].\n\nThe feedback is based on the survey responses you have provided. The feedback include tips based on higher education pedagogical research to support studying. In addition, you can compare your responses in the various sections of the survey to those of other students.\n\nThis message has been automatically sent by UniHow. You cannot reply to the message. UniHow is a Finnish support tool for learning and teaching development, which Funidata Oy and the University of Helsinki are developing jointly. For more information about Funidata and UniHow, visit https://funidata.fi/palvelut/unihow.\n",
      "COURSE_SURVEY": "",
      "HUP": "Hi!\n\nYou have completed the PhD survey about your experiences of doctoral studies. See the feedback in UniHow at [QUESTIONNAIRE_FEEDBACK_LINK_TAG].\n\nThe feedback is based on your survey responses. The feedback include tips to support your doctoral studies based on research on doctoral education. You can also compare your responses in the various sections of the survey to those of other doctoral researchers.\n\nThis message has been automatically sent by UniHow. You cannot reply to the message. UniHow is a Finnish support tool for learning and teaching development, which Funidata Oy and the University of Helsinki are developing jointly. For more information about Funidata and UniHow, visit https://funidata.fi/palvelut/unihow.\n",
      "HUT": "Hi!\n\nYou have completed the HowUTeach survey about your experiences on teaching. See the feedback in UniHow at [QUESTIONNAIRE_FEEDBACK_LINK_TAG].\n\nThe feedback is based on your survey responses. The feedback include tips to support your teaching. You can also compare your responses in the various sections of the survey to those of other teachers.\n\nThis message has been automatically sent by UniHow. You cannot reply to the message. UniHow is a Finnish support tool for learning and teaching development, which Funidata Oy and the University of Helsinki are developing jointly. For more information about Funidata and UniHow, visit https://funidata.fi/palvelut/unihow.\n"
    },
    "defaultSurveyReminderTitle": {
      "DEGREE_PROGRAM_SURVEY": "Invitation to HowULearn survey",
      "COURSE_SURVEY": "",
      "HUP": "Invitation to PhD survey",
      "HUT": "Invitation to HowUTeach survey"
    },
    "defaultSurveyReminderContent": {
      "DEGREE_PROGRAM_SURVEY": "Hi!\n\nYou have not yet completed the HowULearn survey on learning and teaching. HowULearn surveys support students’ learning and studying and the development of teaching quality. Once the survey has ended, you will receive personal feedback based on your responses.\n\nYou can complete the survey after logging into the service with your higher education institution's account.\n\nView the survey: [QUESTIONNAIRE_LINK_TAG].\n\nPlease complete the survey by [QUESTIONNAIRE_END_DATE_TAG].\n\nThank you in advance for participating!\n\nThis message has been automatically sent by UniHow. You cannot reply to the message. UniHow is a Finnish support tool for learning and teaching development, which Funidata Oy and the University of Helsinki are developing jointly. For more information about Funidata and UniHow, visit https://funidata.fi/palvelut/unihow.\n",
      "COURSE_SURVEY": "",
      "HUP": "Hi!\n\nYou have not yet completed the PhD survey about doctoral researchers’ experiences.\n\nThe goal of the PhD survey is to help you analyse your experiences of doctoral studies and identify the factors that affect it. The survey feedback will be used in the development of doctoral education. Once the survey has ended, you will receive personal feedback based on your responses.\n\nYou can complete the survey after logging into the service with your higher education institution's account.\n\nView the survey: [QUESTIONNAIRE_LINK_TAG].\n\nPlease complete the survey by [QUESTIONNAIRE_END_DATE_TAG].\n\nThank you in advance for participating!\n\nThis message has been automatically sent by UniHow. You cannot reply to the message. UniHow is a Finnish support tool for learning and teaching development, which Funidata Oy and the University of Helsinki are developing jointly. For more information about Funidata and UniHow, visit https://funidata.fi/palvelut/unihow.\n",
      "HUT": "Hi!\n\nYou have not yet completed the HowUTeach survey on teaching. Once the survey has ended, you will receive personal feedback based on your responses.\n\nYou can complete the survey after logging into the service with your higher education institution's account.\n\nView the survey: [QUESTIONNAIRE_LINK_TAG].\n\nPlease complete the survey by [QUESTIONNAIRE_END_DATE_TAG].\n\nThank you in advance for participating!\n\nThis message has been automatically sent by UniHow. You cannot reply to the message. UniHow is a Finnish support tool for learning and teaching development, which Funidata Oy and the University of Helsinki are developing jointly. For more information about Funidata and UniHow, visit https://funidata.fi/palvelut/unihow.\n"
    },
    "defaultSurveyIntroduction": {
      "DEGREE_PROGRAM_SURVEY": "<p>Welcome to take the HowULearn survey!</p><p>The purpose of the HowULearn survey is to obtain information about teaching and how students study. Think about your own studies, learning and current study situation. The questions and statements in HowULearn are based on research on higher education and teaching. There are no good or poor answers to the questions. Please answer each question as best you can and as sincerely as possible.</p><p>Once the survey has ended, you will receive personal feedback based on your responses. The feedback also includes research-based tips that support learning, formulated by senior lecturers in university pedagogy and counselling psychologists.</p>",
      "COURSE_SURVEY": "",
      "HUP": "<p>Welcome to the PhD survey!</p><p>The PhD survey will provide insight into doctoral researchers’ experiences of doctoral studies. The questions and statements in the survey are based on research on doctoral education. There are no good or bad answers to the questions. The survey will take approximately 15–20 minutes to complete. When the survey has ended, the system will give you feedback on your answers. The feedback will include information and tips that can help you analyse your dissertation experience and identify factors that affect it. The feedback is based on research on doctoral education. Only you will see your feedback. The collected data will only be used for statistical purposes at group level, and individual respondents’ responses will not be reported.</p>",
      "HUT": "<p>Welcome to take the HowUTeach survey!</p><p>The purpose of the HowUTeach survey is to obtain information about teachers' experiences on their teaching, work community and well-being. The questions and statements in HowUTeach are based on research on higher education and teaching. There are no good or poor answers to the questions. Please answer each question as best you can and as sincerely as possible.</p><p>Once the survey has ended, you will receive personal feedback based on your responses. The feedback also includes research-based tips that support teaching, formulated by senior lecturers in university pedagogy.</p>"
    },
    "defaultSurveyConclusion": {
      "DEGREE_PROGRAM_SURVEY": "<p>Thank you for your participation!</p><p>Once the survey closes, you will be able to access the feedback based on the answers you have provided. The feedback also includes research-based tips that support learning, formulated by senior lecturers in university pedagogy and counselling psychologists. In addition, you can compare your responses in the various sections of the survey to those of other students.</p><p>The service also compiles a summary of the responses, with the responses processed at the group level. Based on the feedback of the survey, the education organiser, your teachers and the education management can develop the teaching to better support the students’ studies and the quality of the teaching.</p><p>You will receive an e-mail when your feedback is available on the UniHow service.</p>",
      "COURSE_SURVEY": "",
      "HUP": "<p>Thank you for participating!</p><p>Once the survey closes, you will be able to view the feedback based on the answers you have provided. The feedback include tips from researchers and experts of doctoral education to support your doctoral studies. You can also compare your answers in the various sections of the survey to those of other doctoral researchers who participated in the survey.</p><p>The service also creates a summary of the responses at group level. Based on the survey feedback, doctoral education can be developed to better support the progress and well-being of doctoral researchers.</p><p>You will receive an email when your feedback is available in UniHow.</p>",
      "HUT": "<p>Thank you for participating!</p>Once the survey closes, you will be able to access the feedback based on the answers you have provided. The feedback also includes research-based tips that support teaching, formulated by senior lecturers in university pedagogy. In addition, you can compare your responses in the various sections of the survey to those of other respondents.</p><p>The service also compiles a summary of the responses, with the responses processed at the group level.</p><p>You will receive an e-mail when your feedback is available on the UniHow service.</p>"
    },
    "likert5DefaultOptions": {
      "1": "Completely disagree",
      "2": "Disagree",
      "3": "Neither agree nor disagree",
      "4": "Agree",
      "5": "Completely agree"
    },
    "likert6DefaultOptions": {
      "1": "Completely disagree",
      "2": "Disagree",
      "3": "Partly disagree",
      "4": "Partly agree",
      "5": "Agree",
      "6": "Completely agree"
    },
    "likert7DefaultOptions": {
      "1": "Completely disagree",
      "2": "Disagree",
      "3": "Partly disagree",
      "4": "Neither agree nor disagree",
      "5": "Partly agree",
      "6": "Agree",
      "7": "Completely agree"
    },
    "likertDefaultOptions": {
      "agree": "Completely agree",
      "neutral": "Neither agree nor disagree",
      "disagree": "Completely disagree"
    },
    "defaultRelativeFeedback": "Your result was {{USER_RESULT}} while the entire group’s average was {{GROUP_RESULT}}.",
    "defaultFeedbackIntroductionContent": {
      "DEGREE_PROGRAM_SURVEY": "You have responded to a HowULearn survey about, among other things, your preferences and habits related to studying and learning. The survey provides information about your own way of studying and your experiences of the learning environment in relation to the responses of the whole group.\n\nIn the feedback, you can first see how you have responded to each aspect of the survey. Based on your responses, you will receive feedback on how your answers reflect these aspects. The aspects consist of several different statements, not individual questions. Remember that the responses are based on your own interpretation of your own learning. They are not permanent features. You can use the feedback to develop your own study skills.\n",
      "COURSE_SURVEY": "You have responded to a HowULearn survey about, among other things, your preferences and habits related to studying and learning. The survey provides information about your own way of studying and your experiences of the learning environment in relation to the responses of the whole group.\n\nIn the feedback, you can first see how you have responded to each aspect of the survey. Based on your responses, you will receive feedback on how your answers reflect these aspects. The aspects consist of several different statements, not individual questions. Remember that the responses are based on your own interpretation of your own learning. They are not permanent features. You can use the feedback to develop your own study skills.\n",
      "HUP": "You have completed a survey about your dissertation experience. The survey can help you understand and compare your experience to the experiences of other doctoral researchers.\n\nIn the feedback, you will first see how you responded in the different sections of the survey compared to other doctoral researchers. This feedback is based on statements about each theme, not on individual statements. After the feedback, you will receive information and tips on the following themes: 1) motivation; 2) supervisory support; 3) research community support; 4) research engagement; and 5) burnout. Your experience may vary at different stages of the process. You can use the feedback to support your doctoral study path.\n",
      "HUT": "You have responded to a HowUTeach survey.\n\nIn the feedback, you can first see how you have responded to each aspect of the survey. Based on your responses, you will receive feedback on how your answers reflect these aspects. The aspects consist of several different statements, not individual questions. Remember that the responses are based on your own interpretation of your own teaching. You can use the feedback to develop your own teaching.\n"
    },
    "researchAgreement": {
      "petition": {
        "DEGREE_PROGRAM_SURVEY": "<p>We ask for your permission to use your answers in research on student learning and student experiences of learning environments. In connection with research use, the study attainment and study right data of the student information system and the log data of the UniHow system (further explained in the data protection notice) may be combined with the answers you provide in this survey. Data on individual students will not be reported at any time. The materials are processed, analysed and stored confidentially. The feedback in reported in accordance with good scientific practices.</p><p>Granting a research permit is completely voluntary and does not affect the feedback you receive. The research permit can also be revoked.</p>",
        "COURSE_SURVEY": "<p>We ask for your permission to use your answers in research on student learning and student experiences of learning environments. In connection with research use, the study attainment and study right data of the student information system and the log data of the UniHow system (further explained in the data protection notice) may be combined with the answers you provide in this survey. Data on individual students will not be reported at any time. The materials are processed, analysed and stored confidentially. The feedback is reported in accordance with good scientific practices.</p><p>Granting a research permit is completely voluntary and does not affect the feedback you receive. The research permit can also be revoked.</p>",
        "HUP": "<p>We ask for your permission to use your answers in research. In connection with research use, the study attainment and study right data of the student information system and the log data of the UniHow system (further explained in the data protection notice) may be combined with the answers you provide in this survey. Data on individual students will not be reported at any time. The materials are processed, analysed and stored confidentially. The feedback is reported in accordance with good scientific practices.</p><p>Granting a research permit is completely voluntary and does not affect the feedback you receive. The research permit can also be revoked.</p>",
        "HUT": "<p>We ask for your permission to use your answers in research. Data on individual respondents will not be reported at any time. The materials are processed, analysed and stored confidentially. The feedback is reported in accordance with good scientific practices.</p><p>Granting a research permit is completely voluntary and does not affect the feedback you receive. The research permit can also be revoked.</p>"
      },
      "furtherInformation": "Further information on research use and revocation of research permits: ",
      "privacyNotice": "Data protection notice for research use:"
    }
  },
  "surveysLandingPage": {
    "title": "Surveys",
    "hulSurvey": "HowULearn survey",
    "hulSurveyDescription": "The statements in a HowULearn survey relate to, among other things, the commitment, well-being, and study experiences of students and their opinions about the learning environment. A HowULearn survey aims to find out about the student’s experiences related to a study module and does not focus on specific courses or series of studies.",
    "husSurvey": "HowUStudy survey",
    "husSurveyDescription": "HowUStudy surveys are used to collect feedback on an individual course or study module instead of the traditional course feedback form. HowUStudy surveys are more simplified than HowULearn surveys.",
    "hupSurvey": "PhD survey",
    "hupSurveyDescription": "The statements in the PhD survey address doctoral researchers’ experiences of doctoral studies. The survey investigates their experiences regarding motivation, well-being during doctoral studies, and the support from supervisor and the scholarly community.",
    "hutSurvey": "HowUTeach survey",
    "hutSurveyDescription": "HowUTeach surveys can be used as a self-reflection tool for higher education teachers. The statements in a HowUTeach survey relate, for example, to teachers' experiences on their own teaching, work community, and well-being.",
    "buttons": {
      "start": "Start survey",
      "browse": "Browse surveys"
    }
  },
  "selectSchemaDialog": {
    "title": "Start a new ${ schemaType }",
    "selectSchema": "Select survey template"
  },
  "selectSchemaTypeDialog": {
    "title": "Select a survey type",
    "label": "Select the survey type for which you want to create a survey template"
  },
  "selectSurveyPartTypeDialog": {
    "surveyPartLabel": "Select the survey type for which you want to create a survey element",
    "extraPartLabel": "Select the survey type for which you want to create an additional question"
  },
  "adminTools": {
    "title": "Administrator tools",
    "permissions": "Permissions",
    "activityLog": "Activity log"
  },
  "accessibilityStatement": {
    "mainTitle": "Accessibility statement",
    "generalInfo": "This is the accessibility statement for the UniHow online service. The accessibility statement has been updated 18 March 2026. Online services are governed by the Act on the Provision of Digital Services, which requires that public online services must be accessible. The accessibility of the online service has been assessed by an external expert organisation.",
    "accessibilityStatementHeading": "Accessibility status of the digital service",
    "accessibilityStatementContent": "This online service partially meets the accessibility requirements.",
    "nonAccessibleContentHeading": "Non-accessible content",
    "nonAccessibilityGeneralInfo": "The online service is not yet fully compliant with accessibility requirements. The following content and/or functionalities are not yet compliant:",
    "listOfAccessibilityErrors": [
      {
        "heading": "General, applicable to the entire online service",
        "descriptionList": [
          "The online service does not inform the user about the time limit set for automatic logout. (WCAG 2.2.1)"
        ]
      },
      {
        "heading": "Front page",
        "descriptionList": [
          "The button for closing the Contact modal is missing a text alternative. (WCAG 4.1.2).",
          "The message field for the Contact modal is missing an accessible label. (WCAG 1.1.1, 3.3.2, 4.1.2).",
          "The ‘thank you’ message of the Contact component has insufficient contrast. (WCAG 1.4.3)."
        ]
      },
      {
        "heading": "Feedback",
        "descriptionList": [
          "Screen readers are unable to read the “Group average” text due to an error in the HTML code. (WCAG 1.1.1, 1.3.1).",
          "Screen readers are unable to read the percentage figures in charts. (WCAG 1.1.1)."
        ]
      }
    ],
    "contactInformationHeading": "Accessibility feedback and contact information",
    "contactInformationContent": "We welcome any comments, questions, and suggested improvements regarding this online service and its accessibility by e-mail at",
    "governingAgencyHeading": "Supervisory authority",
    "governingAgencyContent": "If you notice any accessibility issues when using this online service, please first give feedback to us, the site administrator. It may take up to 14 days for you to receive a response. If you are not satisfied with the response or do not receive a response within two weeks, you can report the matter to the supervisory authority.",
    "governingAgencyContactHeading": "Contact details of the supervisory authority",
    "governingAgencyName": "Finnish Transport and Communication Agency Traficom\nDigital Accessibility Supervision",
    "governingAgencyUrl": "www.saavutettavuusvaatimukset.fi/en",
    "governingAgencyEmail": "saavutettavuus@traficom.fi",
    "governingAgencyPhoneDescription": "phone switchboard",
    "governingAgencyPhoneNumber": "029 534 5000"
  },
  "errorSummary": {
    "heading": "Fill in or correct the following information"
  }
}
